import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from "react-bootstrap";
import CrossIcon from "assets/img/file-cut-icon.png";

export default function EditEmpAccountStatusModal({ show, canEdit, onHide, currentStatus, onConfirm }) {
    const [accountStatus, setAccountStatus] = useState(currentStatus || 'active');

    // Sync local state when the modal opens with a new employee
    useEffect(() => {
        if (show) {
            setAccountStatus(currentStatus);
        }
    }, [show, currentStatus]);

    const handleStatusChange = (e) => {
        setAccountStatus(e.target.value);
    };

    const handleConfirmEdit = () => {
        if (!canEdit) {
            toast.error("You do not have permission to update account status!", { className: 'toast-error-custom', autoClose: 5000 });
            return;
        }

        // If the user didn't change anything, just close
        if (accountStatus === currentStatus) {
            onHide();
        } else {
            onConfirm(accountStatus); // triggers the second modal
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>Change Account Status</Modal.Title>
                <button onClick={onHide} className="modal-close">
                    <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
                </button>
            </Modal.Header>
            <Modal.Body>
                <h5 className="account-status-header">Select the new account status:</h5>
                <Form.Group className="d-flex account-status-fom">
                    <Form.Check
                        inline
                        type="radio"
                        label="Active"
                        name="accountStatus"
                        value="active"
                        id="status-active"
                        className="m-0 cursor-pointer"
                        checked={accountStatus === 'active'}
                        onChange={handleStatusChange}
                        disabled={!canEdit}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        label="Inactive"
                        name="accountStatus"
                        value="inactive"
                        id="status-inactive"
                        className="m-0 cursor-pointer"
                        checked={accountStatus === 'inactive'}
                        onChange={handleStatusChange}
                        disabled={!canEdit}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="cancel-cta"
                    style={{ color: "white" }}
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button
                    variant="update-cta"
                    style={{ backgroundColor: "red", color: "white" }}
                    onClick={handleConfirmEdit}
                    disabled={!canEdit}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

EditEmpAccountStatusModal.propTypes = {
    show: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    currentStatus: PropTypes.string,
};

EditEmpAccountStatusModal.defaultProps = {
    canEdit: false
};